import React, { useState, useCallback, useEffect, useMemo } from 'react';

import { Column } from 'primereact/column';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { MultiSelect } from 'primereact/multiselect';
import { Container } from './styles';

import AcompanhamentoVendaService from '../../services/AcompanhamentoVendaService';
import CampanhaService from '../../services/CampanhaService';
import AuthService from '../../services/AuthService';
import history from '../../services/history';
import {
  getPageParams,
  errorHandle,
  calcNaxItemsPage,
  isScreenMobile,
  padLeft,
  formatDate,
  isNumber,
} from '../../util/functions';

import { showMessage } from '../../components/MessageDialog';

import BotaoMenuGrid from '../../components/BotaoMenuGrid';

import AcompanhamentoVendaCrud from './crud';
import { StateScreen } from '../constants';
import CrudHeader from '../../components/CrudHeader';
import DataTableSp from '../../components/DataTableSp';
import LabelSp from '../../components/LabelSp';

import DropDownLazy from '../../components/DropdownLazy';
import RevendaService from '../../services/RevendaService';

import ColaboradorService from '../../services/ColaboradorService';
import CalendarSp from '../../components/CalendarSp';
import { cfgPtBr, listaStatus, listaStatusCheckList } from '../../config/Constantes';
import DropdownSp from '../../components/DropdownSp';

export default function AcompanhamentoVenda(props) {
  // useSelectors
  const filterVisible = useSelector(state => state.global.filterVisible);

  // useMemo
  const pageParams = useMemo(() => getPageParams(props.match.params, props.location.search), [
    props.location.search,
    props.match.params,
  ]);

  const colaboradorUsuario =
    !AuthService.isPerfilGerente() && AuthService.getUsuario().colaborador
      ? {
          label: AuthService.getUsuario().colaborador.nome,
          value: AuthService.getUsuario().colaborador.id,
        }
      : null;

  const filterService = useMemo(() => {
    const f = AcompanhamentoVendaService.getFilter();
    f.idRevenda = AuthService.getUsuario().idRevenda;
    if (colaboradorUsuario) {
      f.idColaborador = colaboradorUsuario.value;
    }
    return f;
  }, [colaboradorUsuario]);

  const toBack = pageParams.toBack || '/acompanhamentoVendas';

  // useStates
  const [filter, setFilter] = useState(filterService);
  const [acompanhamentoVendas, setAcompanhamentoVendaes] = useState([]);

  const [pageLimit, setPageLimit] = useState(filterService.limit);
  const [first, setFirst] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSelected, setPageSelected] = useState(0);
  const [revendas, setRevendas] = useState();
  const [colaboradorSelecionado, setColaboradorSelecionado] = useState(colaboradorUsuario);
  const [funcTimeOut, setFuncTimeOut] = useState();
  const [listaStatusSelecionado, setListaStatusSelecionado] = useState(
    JSON.parse(filter.listaStatus)
  );

  const [campanhas, setCampanhas] = useState([]);

  // useCallbacks

  const calcLimit = useCallback(() => {
    let ret;
    if (filterVisible) {
      ret = calcNaxItemsPage(7, 10, 16);
    } else {
      ret = calcNaxItemsPage(13, 17, 22);
    }
    setPageLimit(ret);
    return ret;
  }, [filterVisible]);

  const loadRevenda = useCallback(async () => {
    const r = await RevendaService.findAll({
      limit: 999,
    });

    const retorno = r.items.map(e => {
      return {
        label: e.nome,
        value: e.id,
      };
    });

    setRevendas(retorno);
  }, []);

  const loadCampanha = useCallback(async () => {
    const r = await CampanhaService.findAll({ limit: 999 });

    const retorno = r.items.map(e => {
      return {
        label: e.nome,
        value: e.id,
      };
    });

    setCampanhas(retorno);
  }, []);

  const loadColaborador = useCallback(async _nome => {
    if (_nome !== undefined) {
      const r = await ColaboradorService.findAll({
        nome: _nome,
        limit: 50,
      });

      const retorno = r.items.map(e => {
        return {
          label: e.nome,
          value: e.id,
        };
      });
      return retorno;
    }
    return [];
  }, []);

  const handleBuscar = useCallback(
    async (_filter, _page, resetPage = true) => {
      _filter.page = _page || 0;
      _filter.limit = calcLimit();

      try {
        const result = await AcompanhamentoVendaService.findAll({
          ..._filter,
          resumo: 'resumo',
        });
        setAcompanhamentoVendaes(result.items);

        setTotalRecords(result.totalRecords);
        if (resetPage) {
          setFirst(0);
        }
      } catch (err) {
        errorHandle(err);
      }
    },
    [calcLimit]
  );

  const setFilterAndSearch = useCallback(
    async _filterValue => {
      if (JSON.stringify(_filterValue) !== JSON.stringify(filter)) {
        setFilter(_filterValue);

        if (funcTimeOut) {
          clearTimeout(funcTimeOut);
        }
        const func = setTimeout(async () => {
          handleBuscar(_filterValue);
        }, 800);
        setFuncTimeOut(func);
      }
    },
    [filter, funcTimeOut, handleBuscar]
  );

  function onPage(event) {
    const pagina = event.first / event.rows;
    setPageSelected(pagina);
    setFirst(event.first);
    handleBuscar(filter, pagina, false);
  }

  // useCallbacks
  const excluirRegistro = useCallback(
    async _id => {
      try {
        await AcompanhamentoVendaService.delete(_id);
        toast.success('Registro excluído com sucesso.');
        handleBuscar(filter);
      } catch (err) {
        errorHandle(err);
      }
    },
    [filter, handleBuscar]
  );

  // functions
  function getTitle() {
    const titleDefault = 'Acompanhamento de Venda';
    let titleAdd = '';

    if (pageParams.stateScreen === StateScreen.stSearch) {
      titleAdd = '';
    }
    if (pageParams.stateScreen === StateScreen.stInsert) {
      titleAdd = '(Novo)';
    }
    if (pageParams.stateScreen === StateScreen.stUpdate) {
      titleAdd = `(Alterando Id: ${pageParams.idSelected})`;
    }
    if (pageParams.stateScreen === StateScreen.stView) {
      titleAdd = ` (Visualizando Id: ${pageParams.idSelected})`;
    }

    if (!isScreenMobile()) {
      return `${titleDefault} ${titleAdd}`;
    }

    return titleDefault;
  }

  function bloqueiaRevenda() {
    return (
      AuthService.getUsuario() &&
      AuthService.getUsuario().idRevenda &&
      !AuthService.isPerfilGerente()
    );
  }

  function corStatus(status) {
    switch (status) {
      case 0:
        return '#ee3902';
      case 1:
        return '#ebd300';
      case 2:
        return '#049e25';
      case 3:
        return '#007ad9';
      case 4:
        return '#ff854a';
      default:
        return ' ';
    }
  }

  const confirmaExclusao = useCallback(
    id => {
      showMessage('Confirmação', 'Confirma a exclusão do registro?', idx => {
        if (idx === 1) {
          excluirRegistro(id);
        }
      });
    },
    [excluirRegistro]
  );

  // useEffects
  useEffect(() => {
    if (pageParams.stateScreen === StateScreen.stSearch) {
      handleBuscar(filter, 0, true);
    }
    loadRevenda();
    loadCampanha();
    // desativado para evitar que a cada vez que o acompanhamentoVenda digitasse o sistema buscasse
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffects
  // Responsavel por recalcular a quantidade de registros da grid quando a div do filtro ocultar
  // ou ficar visivel
  useEffect(() => {
    if (pageParams.stateScreen === StateScreen.stSearch) {
      calcLimit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calcLimit]);

  // renders
  return (
    <Container className="container-page page-enter-tab">
      <div className="p-grid">
        <CrudHeader
          title={getTitle()}
          disabledButtonInsert={!AuthService.checkRoles('ACOMPANHAMENTO_VENDA_INSERIR')}
          showButtonFilter={pageParams.stateScreen === StateScreen.stSearch}
          showButtonInsert
          showButtonSearch
          titleFilterDefault="Buscar por Razão Social"
          handleFilterDefault={text => {
            filter.razaoSocial = text;
            setFilter({ ...filter, razaoSocial: text });
            handleBuscar(filter);
          }}
          handleClearFilters={() => {
            setFilter({
              ...filter,
              descricao: '',
              idRevenda: null,
              cliente: null,
              idCliente: 0,
              listaStatus: '["0", "1", "2"]',
            });
            setListaStatusSelecionado(JSON.parse('["0", "1", "2"]'));
          }}
          handleButtonInsert={() => history.push('/acompanhamentoVendas/insert')}
          handleButtonSearch={() => handleBuscar(filter)}
        >
          <div className="p-col-12 p-md-3 p-lg-3 p-fluid">
            <LabelSp>Tipo Período</LabelSp>
            <DropdownSp
              options={[
                { label: 'Dt. Lançamento', value: 0 },
                { label: 'Dt. Próx. Contato', value: 1 },
                { label: 'Dt. Últ. Contato', value: 2 },
              ]}
              value={filter.tipoPeriodo}
              onChange={e => {
                setFilterAndSearch({
                  ...filter,
                  tipoPeriodo: e.target.value,
                });
              }}
            />
          </div>
          <div
            className="p-grid p-col-12 p-md-5 p-lg-5 p-fluid"
            style={{ margin: 0, padding: 0 }}
          >
            <div className="p-col-6 p-fluid">
              <LabelSp htmlFor="dataInicial">De: </LabelSp>
              <CalendarSp
                showIcon
                showOnFocus={false}
                appendTo={document.body}
                dateFormat="dd/mm/yy"
                yearNavigator
                locale={cfgPtBr}
                id="dataInicial"
                value={filter.dataInicio}
                yearRange="2010:2040"
                onChange={e => {
                  setFilterAndSearch({ ...filter, dataInicio: e.value });
                }}
              />
            </div>

            <div className="p-col-6 p-fluid">
              <LabelSp htmlFor="dataFinal">Até: </LabelSp>
              <CalendarSp
                showIcon
                showOnFocus={false}
                appendTo={document.body}
                locale={cfgPtBr}
                id="dataFinal"
                dateFormat="dd/mm/yy"
                value={filter.dataFim}
                yearNavigator
                yearRange="2010:2040"
                onChange={e => setFilterAndSearch({ ...filter, dataFim: e.value })}
              />
            </div>
          </div>

          <div className="p-col-12 p-md-4 p-lg-4 p-fluid">
            <LabelSp>Revenda</LabelSp>
            <DropdownSp
              placeholder="Todos"
              showClear
              disabled={bloqueiaRevenda()}
              onChange={e => {
                setFilterAndSearch({ ...filter, idRevenda: e?.value });
              }}
              options={revendas}
              value={filter.idRevenda}
            />
          </div>

          <div className="p-col-12 p-md-6 p-lg-6 p-fluid">
            <LabelSp>Colaborador</LabelSp>
            <DropDownLazy
              autoLoad
              placeholder="Todos"
              showClear
              onChange={e => {
                setColaboradorSelecionado(e);
                setFilterAndSearch({ ...filter, idColaborador: e?.value });
              }}
              value={colaboradorSelecionado}
              onFilter={async txtFilter => {
                const retorno = await loadColaborador(txtFilter);
                return retorno;
              }}
            />
          </div>

          <div className="p-col-12 p-md-6 p-lg-6 p-fluid">
            <LabelSp>Campanha</LabelSp>
            <DropdownSp
              placeholder="Todos"
              showClear
              onChange={e => {
                setFilterAndSearch({ ...filter, idCampanha: e?.value });
              }}
              options={campanhas}
              value={filter.idCampanha}
            />
          </div>

          <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
            <LabelSp>Status</LabelSp>
            <MultiSelect
              value={listaStatusSelecionado}
              options={listaStatusCheckList}
              selectedItemTemplate={selectedCarTemplate}
              maxSelectedLabels={5}
              onChange={e => {
                setListaStatusSelecionado(e.value);
                setFilterAndSearch({ ...filter, listaStatus: JSON.stringify(e.value) });
              }}
            />
          </div>
        </CrudHeader>
        {pageParams.stateScreen === StateScreen.stSearch ? renderSearch() : renderCrud()}
      </div>
    </Container>
  );

  function renderSearch() {
    return (
      <>
        <div className="p-col-12 p-fluid datatable-doc-demo">
          <DataTableSp
            value={acompanhamentoVendas}
            style={{ marginBottom: '2px' }}
            paginator
            rows={pageLimit}
            lazy
            responsive
            totalRecords={totalRecords}
            first={first}
            onPage={onPage}
          >
            <Column
              field="id"
              header=" "
              style={{ width: 30 }}
              body={rowData => {
                const cor = corStatus(rowData.status);
                return (
                  <div
                    className="div-status"
                    style={{
                      background: cor,
                      color: cor,
                    }}
                  >
                    A
                  </div>
                );
              }}
            />
            <Column
              field="id"
              header="Id"
              className="grid-col-id-p"
              body={rowData => padLeft(rowData.id, 5)}
            />
            <Column
              field="dataLancamento"
              header="Data Lançto"
              className="grid-col-data-hora-p grid-col-center"
              body={rowData => formatDate(rowData.dataLancamento, 'dd/MM/yyyy')}
            />
            <Column
              field="dataProximoContato"
              header="Próx. Contato"
              className="grid-col-data-hora-p grid-col-center"
              body={rowData => formatDate(rowData.dataProximoContato, 'dd/MM/yyyy')}
            />
            <Column
              field="dataContato"
              header="Últ. Contato"
              className="grid-col-data-hora-p grid-col-center"
              body={rowData => formatDate(rowData.dataContato, 'dd/MM/yyyy')}
            />

            <Column
              field="nomeColaborador"
              className="grid-col grid-col-nowrap p-p-6"
              style={{ width: 140 }}
              header="Consultor"
            />
            <Column
              field="razaoSocial"
              className="grid-col p-p-4 grid-col-nowrap"
              header="Razão Social"
            />
            <Column
              field="nomeMunicipio"
              className="grid-col grid-col-nowrap"
              header="Município"
            />
            <Column
              field="telefones"
              className="grid-col grid-col-nowrap"
              header="Telefones"
            />

            <Column
              className="gid-col-acoes-35"
              bodyStyle={{ textAlign: 'end' }}
              body={renderButtonOp}
            />
          </DataTableSp>
        </div>
      </>
    );
  }

  function renderButtonOp(rowData) {
    return (
      <BotaoMenuGrid
        handles={[
          () => history.push(`/acompanhamentoVendas/${rowData.id}?view`),
          () => history.push(`/acompanhamentoVendas/${rowData.id}`),
          () => confirmaExclusao(rowData.id),
        ]}
        disableds={[
          false,
          !AuthService.checkRoles('ACOMPANHAMENTO_VENDA_ALTERAR'),
          !AuthService.checkRoles('ACOMPANHAMENTO_VENDA_EXCLUIR'),
        ]}
      />
    );
  }

  function renderCrud() {
    return (
      <AcompanhamentoVendaCrud
        idSelected={pageParams.idSelected}
        stateScreen={pageParams.stateScreen}
        onClose={() => {
          history.push(toBack);
          handleBuscar(filter, pageSelected, false);
        }}
      />
    );
  }

  function selectedCarTemplate(option) {
    if (isNumber(option)) {
      const cor = corStatus(Number(option));
      const item = listaStatus[option];
      return (
        <div className="multiselected-item">
          <div
            className="div-status"
            style={{
              marginRight: 3,
              background: cor,
              color: cor,
            }}
          >
            A
          </div>
          <span>{item.label}</span>
        </div>
      );
    }

    return <span>Todos</span>;
  }
}
